import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Control, Errors } from 'react-redux-form';
import classnames from 'classnames';

class Select extends Component {
    render() {
        let valid = this.props.valid;
        let touched = this.props.touched;
        const mappedValues = {
            1: 'ChainOfCommand',
            2: 'Region',
            3: 'District',
            4: 'RS',
            5: 'RSS',
            6: 'OSS'
        };
        if (this.props.assignSelect) {
            valid = this.props.assignSelect.valid;
            touched = this.props.assignSelect.touched;
        }
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !valid && touched
        });

        let renderOption = !this.props.optGroup
            ? this.props.options.map((opt, index) => {
                  return (
                      <option
                          key={`${index}`}
                          value={opt.code}
                          data-type={opt.type}
                      >
                          {opt.name}
                      </option>
                  );
              })
            : null;
        let renderGroupOption = this.props.optGroup
            ? Object.keys(this.props.options).map(key => (
                  <optgroup key={mappedValues[key]} label={mappedValues[key]}>
                      {this.props.options[key].map((obj, index) => (
                          <option
                              data-type={obj.type}
                              data-value={obj.code}
                              key={`${key}-${index}`}
                              value={`${key}-${index}`}
                          >
                              {obj.name}
                          </option>
                      ))}
                  </optgroup>
              ))
            : null;

        const defaultSelection = this.props.changeDefault
            ? this.props.changeDefault
            : 'Choose';
        return (
            <div className={formRowClassNames}>
                <label htmlFor={this.props.model} className="form__label">
                    <span className="form__title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </span>
                    <Control.select
                        model={this.props.model}
                        id={this.props.model}
                        className="form__select"
                        validators={this.props.validators}
                        onChange={this.props.onChange}
                        disabled={this.props.disabled}
                        defaultValue={this.props.defaultValue}
                    >
                        <option key={defaultSelection} value="">
                            {defaultSelection}
                        </option>
                        {renderGroupOption || renderOption}
                    </Control.select>
                </label>
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => ({
    valid: get(state.forms, `${model}.valid`, false),
    touched: get(state.forms, `${model}.touched`, false)
});

export default connect(mapStateToProps)(Select);



// WEBPACK FOOTER //
// ./src/components/ui/select.js